import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Footer.scss';

//icons
import settingsIcon from '../../assets/settings.png'
import logo from '../../assets/logo.png';
import background from '../../assets/footer-background.png';
import { pushAndStop } from '../../redux/actions/text.action';

class Footer extends Component<{ navigateTo: any }, {}> {
  /**
   * Main render method
   */
  render() {
    return (
      <div className="footer">
        <div className="container">
          <img src={background} className="background" alt="background" />
          <div className="settings" onClick={() => {
            this.props.navigateTo('/selectavatar')
          }}>
            <img src={settingsIcon} className="settings-img" alt="settings_icon" />
            <div className="text">Tobi wechseln</div>
          </div>
          <img src={logo} className="logo" alt="logo" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {

  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    navigateTo(path: string) {
      dispatch(pushAndStop(path));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);